module.exports = __webpack_public_path__ + "static/media/orderPage.6f591379.png";